export const plantasColumns = [
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'ciudad', label: 'Ciudad', type: 'text', sortable: true, required: true },
  { id: 'direccion', label: 'Dirección', type: 'text', sortable: true, required: true },
  { id: 'telefono', label: 'Teléfono', type: 'text', sortable: true, required: true },
  { id: 'encargado', label: 'Encargado', type: 'text', sortable: true, required: true },
];

export const columnsExcel = plantasColumns.map(col => ({ key: col.id, header: col.label }));
